import styled from 'styled-components/macro';
import { Button } from '../../shared/button';

export const SmallButton = styled(Button)`
  min-width: 80px;
`;
